import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useProducts } from "../../Context/ProductContext"; 

const AllProduct = () => {
  const { products, isLoading } = useProducts();

  // Helper function to calculate discount percentage
  const calculateDiscount = (mrp, price) => {
    if (!mrp || !price) return null;
    const numMrp = parseFloat(mrp.replace(/[₹,]/g, ''));
    const numPrice = parseFloat(price.replace(/[₹,]/g, ''));
    if (isNaN(numMrp) || isNaN(numPrice) || numMrp <= numPrice) return null;
    return Math.round(((numMrp - numPrice) / numMrp) * 100);
  };

  // Logic to determine which products to show
  const displayProducts = useMemo(() => {
    if (!products) return [];

    // 1. Filter for products where the admin has added 'isFeatured: true'
    const featured = products.filter(p => p.isFeatured === true);

    // 2. If the admin picked products, show those (limited to 4)
    if (featured.length > 0) {
      return featured.slice(0, 4);
    }

    // 3. Fallback: If nothing is selected, show the first 4
    return products.slice(0, 4);
  }, [products]);

  if (isLoading) {
    return <div style={{padding: '40px 0', textAlign: 'center'}}>Loading products...</div>
  }
  
  return (
    <section className="all-product-section">
      <div className="all-product-inner">
        <div className="all-product-heading-row">
          <div className="all-product-heading best-small">Featured Collection</div>
        </div>
        <div className="all-product-grid">
          
          {displayProducts.map((p) => {
            const variant = p.variants?.[0];
            const discountPercentage = calculateDiscount(variant?.mrp, variant?.price);

            return (
              <div className="all-product-card" key={p.id}>
                
                {/* --- CHANGED THIS LINE: p.id to p.slug --- */}
                <Link to={`/product/${p.slug || p.id}`} className="all-product-thumb-link">
                  <div className="all-product-thumb">
                    
                    {/* DISCOUNT BADGE ADDED HERE */}
                    {discountPercentage && (
                      <div className="discount-badge">
                        {discountPercentage}% OFF
                      </div>
                    )}

                    {/* Image 1 (Default) */}
                    {p.images[0] && (
                      <img 
                        src={p.images[0]} 
                        alt={p.title}
                        className="product-image-1" 
                      />
                    )}
                    {/* Image 2 (Shows on hover) */}
                    {p.images[1] && (
                      <img 
                        src={p.images[1]} 
                        alt={p.title}
                        className="product-image-2"
                      />
                    )}
                  </div>
                </Link>

                <div className="all-product-meta">
                  <div className="all-product-title">{p.title}</div>
                  <div className="all-product-price-wrapper">
                    <span className="all-product-price">
                      {variant?.price}
                    </span>
                    {/* Show MRP only if it's different from the price */}
                    {variant?.mrp && variant.mrp !== variant.price && (
                      <span className="all-product-mrp">
                        {variant.mrp}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="all-product-viewall-row">
          <Link to="/shop-all" className="all-product-viewall-btn">View All</Link>
        </div>
      </div>
    </section>
  );
};

export default AllProduct;